module.exports = __webpack_public_path__ + "static/media/Ultra_Socks.06b75585.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Ultra_Socks.jpg
// module id = 631
// module chunks = 0